// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1bBbF","disabled":"FileBtn_disabled__vLwDO","warn":"FileBtn_warn__28CMk","fade":"FileBtn_fade__RnIy9"};